import {Helmet} from '@dr.pogodin/react-helmet';
import {Show} from 'platform/foundation';

import {useGetPhotoGuideSettingQuery} from '@dms/api/settings';
import i18n from '@dms/i18n';
import {settingsRoutes} from '@dms/routes';
import {SettingsTemplate} from '@dms/settings/shared';
import {formatDocumentTitle} from '@dms/shared';

import {PhotoGuideForm} from './components/PhotoGuideForm';

const TEST_ID = 'settings-advertising-salesPhotos';

export function SalesPhotosSettings() {
  const {data, isLoading, isFetching, isError, fulfilledTimeStamp} = useGetPhotoGuideSettingQuery();

  return (
    <>
      <Helmet
        title={formatDocumentTitle(
          i18n.t('entity.vehicle.labels.photosCarSales'),
          i18n.t('page.salesSettings.labels.advertising'),
          i18n.t('page.settings.labels.title')
        )}
      />
      <SettingsTemplate
        header={{
          title: i18n.t('entity.vehicle.labels.photosCarSales'),
          breadcrumbs: [
            {
              label: i18n.t('page.salesSettings.labels.advertising'),
              href: settingsRoutes.advertising,
            },
          ],
        }}
        description={i18n.t('page.salesSettings.photoGuide.labels.description')}
        isLoading={isLoading}
        isError={isError}
        data-testid={TEST_ID}
      >
        <Show when={data}>
          {(setting) => (
            // Remounts on every refetch, so the draft starts from the saved value again.
            <PhotoGuideForm
              key={fulfilledTimeStamp}
              saved={setting}
              isRefreshing={isFetching}
              data-testid={TEST_ID}
            />
          )}
        </Show>
      </SettingsTemplate>
    </>
  );
}
